<template>
  <div id="app">
    <Nav />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Layout/Footer";
import Nav from "@/components/Layout/Nav";

export default {
  name: "App",
  components: { Footer, Nav },
  mounted() {
    this.pixel();
  },
  methods: {
    pixel: function () {
      var script = document.createElement("script");
      var time = Date.now();
      script.setAttribute(
        "src",
        "https://px.adentifi.com/Pixels?a_id=4353;uq=" + time + ";"
      );
      document.head.appendChild(script);
    },
  },
};
</script>

<style lang="scss">
#app {
  position: relative;
  font-family: "Gotham", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
